define('features/about-tda',[
  'jquery',
  'zipTools',
  'lib/util/zip',
  'lib/util/map.static',
  'lib/util/tda.config',
  'lib/util/langFromUrl',
  'cookies',
  'modernizr',
  'bat',
  'features/ctas/index',
  'txt!./about.tda.hbs',
  'txt!tmpl/ctas.hbs',
  'lib/transforms/tools.dcr.ctas',
  'lib/analytics/blocks/index',
  'lib/analytics/pageload',
  'lib/analytics/click',
  'lib/analytics/context.add',

  // side effect includes
  'Handlebars',
  'dropkick',
  'h5validate',
  'lib/helpers/toJSON',
  'lib/helpers/if_eq'
], function (
  $,
  zipTools,
  zip,
  mapStatic,
  tdaConfig,
  langFromUrl,
  cookies,
  modernizr,
  bat,
  ctas,
  txtTemplate,
  txtCtas,
  ctaXform,
  blocks,
  anPageLoad,
  anClicks,
  anAddContext
) {
  var __currentTDACode = tdaConfig.tda.code;
  var __isWWW = __currentTDACode === 'WWW';
  function __strStartsWith(str, prefix) {
    return str.indexOf(prefix) === 0;
  }

  var __tmplDetail = Handlebars.compile(txtTemplate);
  var __tmplCtas = Handlebars.compile(txtCtas);

  var aboutTda = aboutTda || {

    init: function (el, config) {
      var self = this;
      var $scope = $(el);
      self.$scope = $scope;
      self.config = config;
      self.ctas = ctaXform(config.params.ctas);

      var promisedDealerCount = __isWWW ? 'null' : self.getDealerCount();
      var mapOptions = {};

      Handlebars.registerPartial('ctasDetail', __tmplCtas({ ctas: self.ctas }));

      self.$scope.append(__tmplDetail(self.config));

      $('head').append('<link rel="canonical" href="https://www.buyatoyota.com/about" />');

      self.contentLinks();
      var $dealersServed = $('.js-dealers-served');
      if (__isWWW) {
        $dealersServed.remove();
        self.wwwCtas();
      } else {
        promisedDealerCount.done(function (aboutPageObj) {
          // only show DOM element if we have data
          // else .js-dealers-served remains hidden via inline CSS in About_Default-Skin.xsl
          if (aboutPageObj) {
            var copy = aboutPageObj.dealerCount >= 100 ? '100+' : aboutPageObj.dealerCount;
            $dealersServed.find('p').text(copy);
            $dealersServed.fadeIn();
          }
        });
      }

      if (cookies.getItem('isConfirmedZip') === 'true') {
        mapOptions = {
          location: zip.getCookiedDefaultFallback(),
          zoom: 11
        }
      } else {
        mapOptions = {
          location: 'USA',
          zoom: 5
        }
      }

      mapStatic(mapOptions).then(function (res) {
        $('.about-find').closest('.container-fullwidth').css({
          'background-image': 'url(' + res + ')'
        });
        bat.util.loader.hideLoader();
      }).catch(function (err) { console.log('mapStatic getMap error: ', err); });

      self.searchForm();

      ctas.dealBuilder();
      ctas.dealerSite(self.$scope);

      self.analytics();
    },

    // Content links use old /en/, /es/ format
    contentLinks: function () {
      var $plinks = $('.about-left p a');
      $plinks.each(function (idx, item) {
        var $item = $(item);
        var href = $item.attr('href');
        var newHref = langFromUrl() === 'es' ? href.replace('es', tdaConfig.site.context_url) : href.replace('en', tdaConfig.site.context_url);
        $item.attr('href', newHref);
      });
    },

    analytics: function () {
      var $scope = this.$scope;

      anAddContext(
        $scope,
        blocks.sectionBlock('About Us')
      );
      anClicks($scope);
      anPageLoad($scope);
    },

    // BAT-3386, WWW only
    wwwCtas: function () {
      var $wwwCTAs = $('.about-left p a, .about-ctas a[href$="schedule-a-test-drive/"], .about-ctas a[href$="contact-dealer/"], .about-ctas a[href$="payment-estimator/"], .about-ctas a[href$="trade-in-value/"]');
      $wwwCTAs.on('click', function (e) {
        var value = $(this).attr('href');
        var siteHomePath = zipTools.getSiteHomePath();
        var directPath = siteHomePath + value;
        cookies.removeItem('geoIgnore', '/', zipTools.getCrossDomainCookieDomain());
        if (__strStartsWith(value, siteHomePath)) {
          directPath = value;
        }
        zipTools.redirectPath = directPath;
        // if already confirmed zip (unlikely, but possible. User hit back button maybe)
        if (cookies.getItem('isConfirmedZip') === 'true') {
          zipTools.promptUserForZip(zip.getCookiedDefaultFallback(), zipTools.redirectPath);
        } else {
          zipTools.detectZip();
        }
        e.preventDefault();
      });
    },

    /*------------------------------------------------------------------------
    Promise obj to get Dealer count
    Once resolved, returns object literal
    obj literal is either pulled from localStorage, or gotten via XHR
    once gotten via XHR the first time, response is saved in localStorage
    ------------------------------------------------------------------------*/
    getDealerCount: function () {
      var deferredDealerCount = $.Deferred();
      var localDealerCount = JSON.parse(sessionStorage.getItem('aboutPage')); // Check localStorage for this data first
      // if we have dealerCount data in localstorage AND it's from current TDA, use that
      if (modernizr.sessionstorage && localDealerCount && (localDealerCount.tda === __currentTDACode)) {
        deferredDealerCount.resolve(localDealerCount);
        // else, go get the dealerCount data and stash in localStorage
      } else {
        $.ajax({
          type: 'GET',
          data: {
            brandId: 1,
            resultsMax: 100,
            searchMode: 'filterOnly',
            excludeAttributeKey: 'ServiceCenterOnly',
            tdaCode: __currentTDACode,
            appKey: '7033548c4e5e4270b5336c904c92c2e2',
            resultsMode: 'starOnly',
            resultsFormat: 'json'
          },
          url: '/DISREST/rest/getDealers',
          dataType: 'json'
        }).done(function (data) {
          var aboutPageObj = {
            tda: __currentTDACode,
            dealerCount: data.showDealerLocatorDataArea.dealerLocator[0].dealerLocatorDetail.length
          };
          deferredDealerCount.resolve(aboutPageObj);
          if (modernizr.sessionstorage) {
            var itemForLocalStore = JSON.stringify(aboutPageObj);
            sessionStorage.setItem('aboutPage', itemForLocalStore);
          }
        }).fail(function (jqXHR, textStatus, errorThrown) {
          console.error('DISREST fail: ', textStatus + errorThrown);
          // on fail, resolve with false
          deferredDealerCount.resolve(false);
        });
      }
      // return promise OBJ wether it was resolved via localstorage or XHR
      return deferredDealerCount.promise();
    },

    locate: function () {
      var success = function (newZip) {
        $('#search-type').find('select').val('zip').change()
          .dropkick('refresh');
        $('#about-search-value').val(newZip).removeClass('ui-state-error').addClass('ui-state-valid');
        $('#search-submit').trigger('click');
      };
      // on fail, we just show the zip entry modal via window.zipTools.reLoadDealerSearchWithoutZip
      zipTools.geoLocationZip.detect(success, zipTools.reLoadDealerSearchWithoutZip);
    },

    // kinda sorta modeled after dealer-panel.js
    searchForm: function () {
      var self = this;
      var isAndroid = $('html').hasClass('android');
      var $inputText = $('#about-search-value');
      var $selectSearchType = $('#search-type select');
      var validationVals = 'numbers';
      var $form = $('form.m-dealer-search');
      var $submitButton = $('#search-submit');

      // Default setup of our form
      $form.h5Validate({});
      $selectSearchType.dropkick({ mobile: false });
      $inputText.prop('type', 'tel');
      $inputText.attr('pattern', '[0-9]*');
      if (cookies.getItem('isConfirmedZip') === 'true') {
        $inputText.addClass('ui-state-valid');
      }

      //fixes voice over input on about-search-value trap.
      $inputText.on('keyup', function (e) {
        // console.log(' KEY UP', e.keyCode, 'SHIFT!', e.shiftKey);
        if (e.keyCode === 9 || (e.keyCode === 9 && e.shiftKey)) {
          // console.log('ALLOW TAB KEY');
          return;
        }
      });
      // Find Dealers click event handler
      $submitButton.on('click keyup', function (e) {

        if (e.keyCode && e.keyCode !== 13) {
          return;
        }
        e.preventDefault();
        var searchType = $selectSearchType.val();
        var query = $inputText.val();
        var param = searchType === 'zip' ? 'zipcode' : searchType;
        var miraiChecked = $('#mirai-dealer-check').prop('checked');
        var dataToAdd = {
          dealer_search_term: query,
          dealer_search_type: searchType,
          dealer_search_results_count: '0',
          dealer_search_brand: 'Toyota'
        };
        // if valid
        if ($inputText.hasClass('ui-state-valid')) {
          bat.util.loader.showLoader();
          var dealerPath = '/dealers/?' + param + '=' + escape(query);
          if (miraiChecked) {
            dealerPath = dealerPath + '&mirai=true'
          }

          $.extend(window.dataLayerBAT.data, dataToAdd);
          window.dataLayerBAT.utils.buildAndFireLinkData($submitButton);
          if (__isWWW) {
            // ON WWW need to prompt for zip so they go to right spot!
            if (searchType === 'zip') {
              zipTools.changeZip(undefined, query, dealerPath, function () {
                window.location.href = dealerPath;
              }, true, false);
            } else {
              zipTools.promptUserForZip(zip.getCookiedDefaultFallback(), dealerPath);
            }
          } else {
            window.location.href = '/' + tdaConfig.site.context_url + dealerPath;
          }
        } else {
          $inputText.focus();
          $inputText.addClass('ui-state-error');
        }
      });

      // Autolocate click event. Specific to the About page. Modal versions use .js-autolocate, attached in zip-tools.js
      $('#autolocate').on('click', function () {
        // remove our geoIgnore cookie, user is no longer ignoring our zip prompt
        cookies.removeItem('geoIgnore', '/', zipTools.getCrossDomainCookieDomain());
        self.locate();
      });

      // ADA KEY HANDLER
      $('#autolocateWrap').on('keypress', function (event) {
        if (event.keyCode === 13) {
          $('#autolocate').trigger('click');
        }
      });

      // Silly key suppression on inputs and search type <select> change event handler
      var stripAndroidNumbers = function () {
        var current = $inputText.val();
        var stripped = current.replace(/[0-9]/g, '');
        $inputText.val(stripped);
      };

      if (!isAndroid) {
        // set default keypress on zip
        $inputText.keydown(function (e) {
          if (e.keyCode === 9) { // ALLOW TAB
            return;
          }
          zipTools.numericInput(e);
        }).keypress(function (e) {
          if (e.keyCode === 9) { // ALLOW TAB
            return;
          }
          zipTools.numericInput(e);
        });
      }

      // taken mainly from dealer-panel.js - FAD search form
      $selectSearchType.on('change', function (event) {
        var placeholderText = $(this).find(':selected').attr('data-placeholder');
        var searchType = $(this).val();

        if (searchType === 'zip') {
          $inputText.prop('type', 'tel');
          $inputText.attr('pattern', '[0-9]*')
            .attr('title', 'Zip Code is required - 5 digits.')
            .data('storage', 'userZip')
            .addClass('h5-zip')
            .removeClass('ui-state-valid');
          validationVals = 'numbers';
        } else if (searchType === 'dealerName') {
          validationVals = 'none';
          $inputText.prop('type', 'text');
          $inputText.data('storage', undefined);
          $inputText.removeAttr('pattern')
            .removeClass('h5-zip')
            .attr('title', 'Dealer Name')
            .removeClass('ui-state-valid');
        } else {
          validationVals = 'all';
          $inputText.prop('type', 'text');
          $inputText.data('storage', undefined);
          $inputText.removeAttr('pattern')
            .removeClass('h5-zip')
            .attr('title', 'City, State')
            .removeClass('ui-state-valid');
        }

        $inputText.attr('aria-label', placeholderText);//ADA UPDATE ARIA LABEL
        $inputText.attr('placeholder', placeholderText).val('');
        if (validationVals === 'all') {
          if (isAndroid) {
            $(document).delegate('#about-search-value', 'input', stripAndroidNumbers);
          } else {
            // prevent numbers from being entered in city/state search
            $inputText.off('keydown', null);
            $inputText.off('keypress', null);
            $inputText.keydown(function (e) {
              zipTools.cityStateInput(e);
            }).keypress(function (e) {
              zipTools.cityStateInput(e);
            });
          }
          $inputText.removeAttr('maxlength');
        } else if (validationVals === 'none') {
          if (isAndroid) {
            $(document).undelegate('#about-search-value', 'input');
          } else {
            $inputText.off('keydown', null);
            $inputText.off('keypress', null);
            $inputText.removeAttr('maxlength');
          }
        } else {
          if (isAndroid) {
            $(document).undelegate('#about-search-value', 'input', stripAndroidNumbers);
          } else {
            // only allow #'s in zip search
            $inputText.off('keydown', null);
            $inputText.off('keypress', null);
            $inputText.keydown(function (e) {
              zipTools.numericInput(e);
            }).keypress(function (e) {
              zipTools.numericInput(e);
            });
          }
          $inputText.attr('maxlength', 5);
        }
      });
    }
  };

  window.addEventListener('pageshow', function (event) {
    if ($('#page-about-tda').length && event.persisted) {
      bat.util.loader.hideLoader();
    }
  });

  return aboutTda;
});

